import { useEffect, useState } from 'react';

// Single source of truth for layout breakpoint decisions. Reads window.matchMedia
// so it stays in sync with CSS expectations.

const MOBILE_MAX = '(max-width: 639px)';

export function useIsNarrow(): boolean {
  const [narrow, setNarrow] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MOBILE_MAX).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_MAX);
    const onChange = (e: MediaQueryListEvent) => setNarrow(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return narrow;
}
